import { Component } from 'react'
import { reportError } from '../utils/errorReporter'

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    reportError(error, {
      componentStack: errorInfo?.componentStack,
      boundary: true,
    })
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '2rem',
          textAlign: 'center',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⚠️</div>
          <h2 style={{ color: '#1e293b', marginBottom: '0.5rem' }}>Произошла ошибка</h2>
          <p style={{ color: '#64748b', marginBottom: '1.5rem', maxWidth: '400px' }}>
            Что-то пошло не так. Мы уже знаем об этой проблеме и работаем над исправлением.
          </p>
          <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', justifyContent: 'center' }}>
            <button
              onClick={this.handleRetry}
              style={{
                padding: '0.6rem 1.5rem',
                borderRadius: '8px',
                border: 'none',
                background: '#4f46e5',
                color: 'white',
                cursor: 'pointer',
                fontSize: '0.95rem',
              }}
            >
              Попробовать снова
            </button>
            <a
              href="https://t.me/UltraCafeBot"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                padding: '0.6rem 1.5rem',
                borderRadius: '8px',
                border: '1px solid #e2e8f0',
                background: 'white',
                color: '#475569',
                textDecoration: 'none',
                fontSize: '0.95rem',
              }}
            >
              Написать в поддержку
            </a>
          </div>
          <p style={{ color: '#94a3b8', fontSize: '0.8rem', marginTop: '1.5rem' }}>
            feedback@ultracafe.ru · @UltraCafeBot
          </p>
        </div>
      )
    }

    return this.props.children
  }
}
